import { useContext } from 'react';
import * as Yup from 'yup';
import { ProductContext } from '../contexts/product_context';
import {
  validationTest,
  isRangeExceeded,
  isTheValueNegative,
  isNotInitiantingWithZerro,
  isUndefined,
  isDecimal,
} from './customValidations';

const emptyMessage = '      ';

function pricingRangesAttributesObject(contextValues) {
  return (
    {
      start_quantity: Yup.number('deve ser numero').test('é required', emptyMessage, (value) => validationTest(value, 'Quntadidede inicial tem que ser definida', isUndefined, contextValues))
        .test('Tem que ser positivo', emptyMessage, (value) => validationTest(value, 'Quantidade inicial tem que ser positiva', isTheValueNegative, contextValues))
        .test('Inteiro', emptyMessage, (value) => validationTest(value, 'Quantidade inicial tem que ser um numero inteiro', isDecimal, contextValues)),
      end_quantity: Yup.number(emptyMessage)
        .test('Required', emptyMessage, (value) => validationTest(value, 'Quantidade final tem que ser definida', isUndefined, contextValues))
        .test('Quantidade final tem que ser positivo', emptyMessage, (value) => validationTest(value, 'Quantidade final tem que ser positivo', isTheValueNegative, contextValues)),
      overage_price: Yup.number('deve ser numero').test('Tem que ser positivo', emptyMessage, (value) => validationTest(value, 'Excedente deve ser positivo', isTheValueNegative, contextValues)),
      price: Yup.number('deve ser numero')
        .test('Required', emptyMessage, (value) => validationTest(value, 'Preço tem que ser definido', isUndefined, contextValues)),
    }
  );
}

function nameValidations() {
  return (Yup.string().required('não pode ficar em branco'));
}

export default function ValidationSchema() {
  const { setPriceRangeErrors, priceRangeErrors } = useContext(ProductContext);
  const contextValues = { setPriceRangeErrors, priceRangeErrors };
  const schema = Yup.object().shape({
    name: nameValidations(),
    pricing_schema_attributes: Yup.object().shape({
      price: Yup.number('')
        .integer('deve ser um número inteiro')
        .positive('deve ser um número positivo')
        .required('não pode ficar em branco'),
      minimum_price: Yup.number()
        .positive('deve ser um número positivo')
        .integer('deve ser um número inteiro'),
      pricing_ranges_attributes: Yup.array().of(
        Yup.object().shape(
          pricingRangesAttributesObject(contextValues),
        ).required(),
      )
        .test('Excedeu limite', emptyMessage, (value) => validationTest(value, 'Excedeu o limite de faixas, no maximo 25', isRangeExceeded, contextValues))
        .test('Tem que iniciar com zero', emptyMessage, (value) => validationTest(value, 'Tem que se iniciar em 0', isNotInitiantingWithZerro, contextValues)),
    }),
  });

  return schema;
}
